var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('h1',{class:_vm.$style.title},[_vm._v("\n    The page timed out while loading. Are you sure you're still connected to\n    the Internet?\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }